export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10423.e2f524b5.jpg";